/* src/app/sidebar/sidebar.component.css */
.sidenav-container {
  height: 100%;
}
.sidenav {
  width: 201px;
}
.sidenav .mat-toolbar {
  background: inherit;
}
.mat-toolbar.mat-primary {
  position: sticky;
  top: 0;
  z-index: 1;
}
.spacer {
  margin-top: 20px;
  padding-right: 20px;
  text-align: right;
  width: 100%;
}
.menu-item {
  width: 100%;
  padding: 0;
  margin: 0;
  width: 200px;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
.menu-item-icon {
}
.has-submenu .spacer {
  padding-right: 38px;
}
.has-submenu::after {
  content: "chevron_right";
  font-family: "Material Icons";
  font-size: 18px;
  line-height: 1;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  opacity: 0.6;
  pointer-events: none;
}
.nav-badge {
  position: absolute;
  left: 30px;
  top: calc(50% - 20px);
  z-index: 1;
  box-sizing: border-box;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--red);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}
.header {
  padding: 15px;
  padding-top: 25px;
  background-color: var(--header-color);
}
.title {
  text-align: center;
  font-size: 150%;
  font-weight: 300;
}
.user {
  width: 100%;
  text-align: center;
  font-size: 70%;
}
.accordion {
  width: 100%;
  padding: 0px;
  padding-left: 20px;
  margin: 0px;
}
.submenu {
  font-size: 12px;
}
.item {
  padding-right: 0;
  margin-right: 0;
  width: 100%;
}
.item-container {
  width: 175px;
  padding: 0;
  margin: 0;
}
.subicon-active {
  background-color: #98aeaf;
}
.ng-select.custom {
  border: 0px;
  min-height: 0px;
  border-radius: 0;
}
.theme-button {
  color: var(--light-text);
}
.logo-image {
  padding-left: 25px;
  padding-top: 21px;
  padding-bottom: 20px;
  padding-right: 25px;
  cursor: pointer;
}
.logo-image-small {
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
  cursor: pointer;
}
::ng-deep .mat-select-value {
  color: var(--primary-color);
}
.copyrights {
  font-size: 10pt;
  position: absolute;
  top: 2px;
}
::ng-deep .company-selector .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  width: 200px;
  background-color: white !important;
}
::ng-deep .company-selector .mdc-line-ripple::before {
  border: none !important;
}
::ng-deep .menu-list .mat-mdc-form-field {
  text-align: center !important;
}
::ng-deep .mat-mdc-selected {
  color: var(--primary-color) !important;
}
/*# sourceMappingURL=sidebar.component.css.map */
